<div class="loading" *ngIf="!allSet">
    <img
        src="./assets/images/boat-loading.gif"
        alt="loading sell process"
        class="loading-image"
    />
    <h1 class="loading-title">
        Reach NZ's largest motor audience.
    </h1>
</div>
<router-outlet *ngIf="allSet"></router-outlet>
